import {useEffect, useState} from "react";
import {AppEntities} from "../../../../../../config/entities";
import {PurchaseOrdersService} from "../../../../../../services/documents/PurchaseOrdersService";
import {IPurchaseOrderDto} from "../dtos/IPurchaseOrderDto";
import {toast} from "react-toastify";
import {IPurchaseOrderModel} from "../models/IPurchaseOrderModel";
import {IPurchaseOrderProductDto} from "../dtos/IPurchaseOrderProductDto";
import {IPurchaseOrderServiceDto} from "../dtos/IPurchaseOrderServiceDto";
import {IPurchaseOrderPaymentOffsetsDto} from "../dtos/IPurchaseOrderPaymentOffsetsDto";

interface IProps {
    documentId?: string;
}

export const useFetchPurchaseOrder = ({documentId}: IProps) => {
    const [isDocumentLoading, setIsDocumentLoading] = useState(false);
    const [documentDto, setDocumentDto] = useState<IPurchaseOrderDto | null>(null);
    const [documentModel, setDocumentModel] = useState<IPurchaseOrderModel | null>(null);
    const dataService = AppEntities.PurchaseOrders.getDataService() as PurchaseOrdersService;

    const postDocument = async () => {
        if (!documentId) return;
        await dataService.PostDocument(documentId);
        toast.success("Document posted successfully");
    }

    const cancelDocument = async () => {
        if (!documentId) return;
        await dataService.CancelDocument(documentId);
        toast.success("Document canceled successfully");
    }
    
    const updateDocument = async (documentModel: IPurchaseOrderModel) => {
        if (!documentId) return;
        console.log(documentModel)
        const requestDto: IPurchaseOrderDto = {...documentModel};
        const responseDto = await dataService.Update(requestDto);
        setDocumentDto(responseDto);
        // toast.success("Document updated successfully");
    }

    const fetchDocument = async () => {
        try {
            setIsDocumentLoading(true);

            console.log("documentId", documentId);

            let responseDto: IPurchaseOrderDto | null = null;
            let responseProductDto: IPurchaseOrderProductDto[] = [];
            let responseServiceDto: IPurchaseOrderServiceDto[] = [];
            let responsePaymentOffsetDto: IPurchaseOrderPaymentOffsetsDto[] = [];

            if (!documentId) {
                responseDto = await dataService.Create({
                    documentDate: new Date(),
                });
                setDocumentDto(responseDto);
            } else {
                responseDto = await dataService.Get(documentId);
                setDocumentDto(responseDto);
            }
            
            if (!responseDto) return;
            
            const newModel: IPurchaseOrderModel = {
                ...responseDto,
                products: [...responseProductDto],
                services: [...responseServiceDto],
                paymentOffsets: [...responsePaymentOffsetDto]
            };
            setDocumentModel(newModel);
        } catch (e) {
            console.log(e);
        } finally {
            setIsDocumentLoading(false);
        }
    }

    useEffect(() => {
        fetchDocument();
    }, [documentId]);

    return {
        isDocumentLoading,
        documentDto,
        documentModel,
        postDocument,
        cancelDocument,
        updateDocument
    }
}